import cn from 'classnames'
import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import SidenavMainContent from 'src/components/SidenavMainContent/SidenavMainContent'
import SidenavSettingsContent from 'src/components/SidenavSettingsContent/SidenavSettingsContent'
import { SidenavContentType } from 'src/navigation/appLocations'

import * as styles from './SidenavContent.style'

export interface SidenavContentProps {
  contentType: SidenavContentType
  onShowMain: () => void
  isSidenavOpen: boolean
}

const SidenavContent: React.FC<SidenavContentProps> = (
  props,
): React.ReactElement => {
  const isSettings = props.contentType === SidenavContentType.Settings

  return (
    <div
      css={styles.sidenavContentContainer}
      data-testid="sidenav-scrollable-content"
    >
      <TransitionGroup>
        <CSSTransition
          key={props.contentType}
          timeout={300}
          classNames="sidenav-transition"
        >
          <div
            css={styles.sidenavTransitionContainer}
            className={cn({
              settings: isSettings,
              main: !isSettings,
            })}
          >
            {isSettings ? (
              <SidenavSettingsContent
                onBackClick={props.onShowMain}
                isSidenavOpen={props.isSidenavOpen}
              />
            ) : (
              <SidenavMainContent isSidenavOpen={props.isSidenavOpen} />
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}

export default SidenavContent
